import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostBinding,
  inject,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';

export type SectionState = 'default' | 'active' | 'highlighted';
export type SectionAppearance = 'default' | 'slim';

/**
 * @deprecated This component is deprecated and should no longer be used.
 * Use `ti-portlet` for the `default` appearance and `kendo-panelbar` for the `slim` appearance instead.
 */
@Component({
  selector: 'ti-modern-section',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modern-section.component.html',
  styleUrls: ['./modern-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModernSectionComponent implements AfterViewInit {
  animated = false;
  @HostBinding('attr.title')
  public readonly hostTitle: null = null;

  @Input()
  public title: string;

  @Input()
  public appearance: SectionAppearance = 'default';

  @Input()
  public expanded: boolean = true;

  @Input()
  public collapsible: boolean = true;

  @Input()
  public state: SectionState = 'default';

  @Input()
  hasBodyPadding: boolean = false;

  @Output()
  public expandedChange = new EventEmitter<boolean>();

  private cdr = inject(ChangeDetectorRef);
  @Input() keepContent: boolean = true;

  ngAfterViewInit() {
    requestAnimationFrame(() => {
      this.animated = true;
      this.cdr.markForCheck();
    });
  }

  public toggle(isExpanded?: boolean) {
    if (!this.collapsible) return;
    this.expanded = isExpanded ?? !this.expanded;
    this.cdr.markForCheck();
    this.expandedChange.emit(this.expanded);
  }
}
